import { UserGroupIcon } from '@hugeicons/core-free-icons';
import { createIcon } from '../icon';

export const Users = /* @__PURE__ */ createIcon(UserGroupIcon, 'Users');
